import { Box } from "@mui/material";
import Picker from "@emoji-mart/react";
import { isBrowser } from "react-device-detect";
import { CDN_ONE_FILE_PATH, CHAT_FOOTER_START_HEIGHT } from "../../common/common";

interface ChatEmojiProps {
  isEmojiOpen: boolean;
  handleEmojiAwayClick: any;
  onEmojiCallback: any;
}

const ChatEmoji = ({ isEmojiOpen, handleEmojiAwayClick, onEmojiCallback }: ChatEmojiProps) => {
  const onEmojiClick = (emoji: any, event: any) => {
    onEmojiCallback(event);
  };
  return (
    <Box className={`pos-fixed ${isBrowser ? "emojiHolder" : "emojiHolderMobile"}`} style={{ display: isEmojiOpen ? "block" : "none", width: isBrowser ? "320px" : "100%", height: isBrowser ? "314px" : "286px" }} sx={{ bottom: isBrowser ? CHAT_FOOTER_START_HEIGHT - 8 : 8, zIndex: 3 }}>
      <Picker
        dynamicWidth
        emojiButtonSize={40}
        emojiSize={32}
        style={{ borderRadius: !isBrowser ? "0px" : "8px" }}
        onClickOutside={handleEmojiAwayClick}
        set="facebook"
        previewPosition="none"
        emoji={{ emoji: require("../../emojisets/facebook.json") }}
        onEmojiSelect={onEmojiClick}
        getSpritesheetURL={() => CDN_ONE_FILE_PATH + "images/emojis/emojis-64.png"}
      />
    </Box>
  );
};

export default ChatEmoji;
